module.exports = __webpack_public_path__ + "static/img/img_o.77ce2812.png";